"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardDataWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardDataWrapperMixin = require("../../mixins/components/PropertyCardDataWrapperMixin");
var StyledPropertyCardDataWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardDataWrapper",
  componentId: "c11n-8-107-0__sc-hfbvv9-0"
})(["", ""], _PropertyCardDataWrapperMixin.PropertyCardDataWrapperMixin);
exports.StyledPropertyCardDataWrapper = StyledPropertyCardDataWrapper;